/**
 * created by xcc
 * 稿件列表模式
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import noImg from './img/noImg.png'
import * as utils from "../../../utils";
import {Table, Tag, Tooltip, Menu, Popover, message, Modal} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import * as Actions from "../../../actions/manuscriptListId";
import './ManuscriptTable.css';
import {Button} from "antd/lib/index";

export default class ManuscriptTable extends Component {
    static defaultProps = {
        title: '校长邱勇：秉持科教融合核心理念 培养高层次拔尖创新人才校长邱勇：秉持科教融新人才校长邱勇：秉持科教融新人才校长邱勇：秉持科教融合核心理念 培养高层次拔尖创新人才',
        newSecondSelectColor:'#0050B3',
    };
    static propTypes = {
        dataList:PropTypes.array.isRequired,//数据源
    };

    constructor(props) {
        super(props);
        this.state = {
            allMedia:[],
            visible:false
        }
    }

// 列
columns = [
    {
        key:'1',
        title: '标题',
        dataIndex: 'title',
        width: "25%",
        ellipsis: true,
        textWrap: 'word-break',
        render:(value, row, index)=>{
            let showContentText = "";
            if (row.content) {
                showContentText = row.content.replace(/<[^>]*>/ig, "");
            }
            return (
            <div className="manuscriptTitle" onClick={() => {this.props.titleClick && this.props.titleClick(row)}}>
                <Tooltip placement="topLeft" title={
                    <div>
                        <div title={row.title} style={{
                            wordWrap: "break-word",
                            wordBreak: "normal",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 6,
                            WebkitBoxOrient: 'vertical',
                            cursor:"pointer"
                        }}><span style={{fontSize:"16px",color:"#0050B3"}}>标题:</span>{row.title}</div>
                        <div title={row.summary===""?showContentText:row.summary} style={{
                            wordWrap: "break-word",
                            wordBreak: "normal",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 6,
                            WebkitBoxOrient: 'vertical',
                            cursor:"pointer"
                        }}><span style={{fontSize:"16px",color:"#0050B3"}}>摘要:</span>{row.summary===""?showContentText:row.summary}</div>
                    </div>                  
                } arrowPointAtCenter>
                    <div style={{cursor:"pointer", overflow: "hidden", textOverflow: "ellipsis", lineClamp: 1, whiteSpace: "nowrap"}}>{row.title}</div>
                </Tooltip>
                </div>
            )
        }
    },
    {
        key:'2',
        title: "",
        dataIndex: 'relevanceTask',
        textWrap: 'word-break',
        width: "15%",
        ellipsis: true,
        align:"center",
        render:(value, row, index)=>{
            return (
                <div style={{display:"flex"}}>
                    <div style={{cursor:"pointer",width:row.interview&&row.topicSelection?"50%":"210px"}} onClick={() => {
                        this.props.task1Click && this.props.task1Click(row)
                    }}>
                        {
                            row.interview && row.interview.id ?
                            <div style={{width:row.interview&&row.topicSelection?"80px":"210px"}}>
                                <Tag color={this.props.newSecondSelectColor}>
                                <div style={{width:row.interview&&row.topicSelection?"80px":"210px",overflow: "hidden", textOverflow: "ellipsis", lineClamp: 1, whiteSpace: "nowrap"}}>
                                <Tooltip placement="topLeft" title={row.interview.title} arrowPointAtCenter={false}>
                                <span style={{marginRight:"3px"}}>任务:</span>{row.interview && row.interview.id ? row.interview.title : ''}
                                </Tooltip>
                                </div>
                            </Tag>
                            </div>
                            
                            :null
                        }              
                    </div>
                    <div style={{cursor:"pointer",width:row.interview&&row.topicSelection?"80px":"210px"}} onClick={() => {
                        this.props.task2Click && this.props.task2Click(row)
                    }}>
                        {
                            row.topicSelection && row.topicSelection.id?
                            <div style={{width:row.interview&&row.topicSelection?"80px":"210px"}}>
                                <Tag color={this.props.newSecondSelectColor}>
                                <div style={{width:row.interview&&row.topicSelection?"80px":"210px",overflow: "hidden", textOverflow: "ellipsis", lineClamp: 1, whiteSpace: "nowrap"}}>
                                <Tooltip placement="topLeft" title={row.topicSelection.tsName} arrowPointAtCenter={false}>
                                    <span style={{marginRight:"3px"}}>选题:</span>{row.topicSelection && row.topicSelection.id ? row.topicSelection.tsName : ''}
                                </Tooltip>
                                </div>
                            </Tag>
                            </div>
                            
                            :null
                        }
                        
                    </div>
                </div>           
                )
        }
    },
    {
        key:'3',
        title: '创建人',
        align:"left",
        dataIndex: 'name',
        width: "11%",
        textWrap: 'word-break',
        render:(value, row, index)=>{
            let sex = row.submitUser && row.submitUser.sex ? row.submitUser.sex : 1;
                                    if (this.props.currentUser)
                                        sex = this.props.currentUser.sex;
                                    let photo = "images/header_boys.png";
                                    /* if (this.props.currentUser && this.props.currentUser.photoUrl && this.props.currentUser.photoUrl.length > 0) {
                                         photo = this.props.currentUser.photoUrl
                                     } else {*/
                                    if (sex === 2) {
                                        photo = "/cm-sites/images/header_girls.png";
                                    }
            return (
                <div style={{display:"flex",justifyContent:"left"}}>
                    <div style={{width:"20px",height:"20px"}}>
                        <img  style={{width:"20px",height:"20px",objectFit:"cover",minHeight:"100%",borderRadius:"50%"}} src={row.submitUser && row.submitUser.photoUrl ? row.submitUser.photoUrl : photo} alt=""/>
                    </div>
                    <div style={{marginLeft:"3px"}}>{row.submitUser ? row.submitUser.name : ''}</div>
                </div>
            )
        }
    },
    
    {
        key:'4',
        title: '创建时间',
        dataIndex: 'createTime',
        textWrap: 'word-break',
        align:"center",
        width: "10%",
        ellipsis: true,
        render:(value, row)=>{
            return <div>{row.submitDate && row.submitDate.time ? utils.formatDate(row.submitDate.time) : ''}</div>
        }
    },
    {
        key:'5',
        title: '修改时间',
        dataIndex: 'updateTime',
        width: "10%",
        align:"center",
        ellipsis: true,
        textWrap: 'word-break',
        render:(value, row, index)=>{
            return <div>{row.changeDate && row.changeDate.time ? utils.formatDate(row.changeDate.time) : ''}</div>
        }
    },
    {
        key:'6',
        title: '状态',
        dataIndex: 'publishStatus',
        textWrap: 'word-break',
        align:"center",
        width: "9%",
        render:(value, row, index)=>{
            let submitStatusName = '';
                                    if (row.copyStorys&&row.copyStorys.length > 0&&this.props.title!=="投稿稿件") {
                                        row.copyStorys.forEach(copyStoryItem => {
                                            if (copyStoryItem.statusName === '发布') {
                                                submitStatusName = '已发布';
                                                copyStoryItem.hoverShow=false;
                                                return;
                                            }
                                        });
                                        if (submitStatusName !== '已发布') {
                                            if (row.statusName === '发布') {
                                                submitStatusName = '已发布';
                                            } else {
                                                submitStatusName = row.statusName;
                                            }
                                        }
                                    } else {
                                        if (row.statusName === '发布') {
                                            submitStatusName = '已发布';
                                        } else {
                                            submitStatusName = row.statusName;
                                        }
                                    }

                                    let usingName='';
                                    if(this.props.mediaType==='other'){
                                        if(row.usingMediaCodes&&row.usingMediaCodes.length>0&&row.usingMediaCodes.indexOf(this.props.mediaCode)>-1){
                                            usingName= <span style={{color:'#00A854'}}>已采用</span>;
                                        }else{
                                            usingName= <span  style={{color:'#FFBF00'}}>未采用</span> ;
                                        }
                                    }
                                 return <div style={{cursor:"pointer"}}>
                                     {this.props.showType==="originalManuscript"&&this.props.manuscriptType!=="投稿稿件"&&this.props.manuscriptType!=="其他媒体稿件"?

                                                        <div
                                                            onClick={()=>{
                                                                this.getInterviewIds(row)
                                                            }}
                                                        >{submitStatusName}  {usingName?'(' :''} {usingName?usingName:''}{usingName?')' :''}</div>

                                         :
                                                                <div>{submitStatusName} {usingName?'(' :''} {usingName?usingName:''}{usingName?')' :''}</div>
                                      }
            </div>
        }
    },
    {
        key:'7',
        title: '操作',
        dataIndex: 'operate',
        width: "20%",
        align:"center",
        ellipsis: true,
        textWrap: 'word-break',
        render:(value, row, index)=>{
            let submitStatusName = '';
                                    if (row.copyStorys&&row.copyStorys.length > 0&&this.props.title!=="投稿稿件") {
                                        row.copyStorys.forEach(copyStoryItem => {
                                            if (copyStoryItem.statusName === '发布') {
                                                submitStatusName = '已发布';
                                                return;
                                            }
                                        });
                                        if (submitStatusName !== '已发布') {
                                            if (row.statusName === '发布') {
                                                submitStatusName = '已发布';
                                            } else {
                                                submitStatusName = row.statusName;
                                            }
                                        }
                                    } else {
                                        if (row.statusName === '发布') {
                                            submitStatusName = '已发布';
                                        } else {
                                            submitStatusName = row.statusName;
                                        }
                                    }
            return <div style={{width:"200px",display:"flex",color:this.props.newSecondSelectColor,marginLeft:"75px"}}>
                {this.props.btn(submitStatusName,row,this.props.newSecondSelectColor,index)}
            </div>
        }
    }
];

// 通过id得到其它稿件详情
getInterviewIds(items){
    Actions.getInterviewId({storyId:items.id},(res)=>{
        // items.hoverShow=true; //每项添加hoverShow属性
    let allMedia=[];
    if(res&&res.data){
        allMedia=res.data;
    }
    if(allMedia.length>0){
        this.setState({
            allMedia,
            visible:true
        })
    }else{
        message.info('没有查询到相关数据')
        // items.hoverShow=false;
    }
    
})
}
renderStatusInfo(){
    return(
        <Modal
            title={"信息"}
            visible={this.state.visible}
            onCancel={()=>this.setState({visible:false})}
            footer={null}
            centered
        >
             <Scrollbars style={{height: 210}}>
                 <div>
                 {this.state.allMedia.map((allMediaItem, allMediaIndex) => {
                     return (
                         <div key={allMediaIndex}>
                             <div style={{display:"flex"}}>
                                 <div title={allMediaItem.mediaInfo.name} style={{cursor:"pointer", width:"120px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap", marginRight:"2px"}}>{allMediaItem.mediaInfo?allMediaItem.mediaInfo.name:"未知"}:</div>
                                 <div title={allMediaItem.statusName} style={{cursor:"pointer", width:"120px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{allMediaItem.statusName}</div>
                             </div>
                         </div>
                     )
                 })}
                 </div>
             </Scrollbars>
        </Modal>
    )
}

    componentWillMount() {
    }

    componentDidMount() {
    }


    render() {
        return (
            <div>
                <div style={{width:"100%"}}>
                    <Table rowKey={record => record.id} style={{width:"100%"}} columns={this.columns} dataSource={this.props.dataList} pagination={false} />
                </div>
                {/*渲染状态信息*/}
                {this.renderStatusInfo()}
            </div>
        )
    }

}